import { BankConnection } from '@core/model/domain/bankConnection';
import { Mapper } from '@core/model/framework/mapper';
import { inject, injectable } from 'inversify';
import { BankConnectionDto } from '@core/service/digital-factory/bank/types/dto/bankConnectionDto';
import { BankConnectionStateMapper } from './bankConnectionStateMapper';

@injectable()
export class BankConnectionMapper implements Mapper<BankConnection, BankConnectionDto> {
  constructor(
    @inject(BankConnectionStateMapper)
    private readonly bankConnectionStateMapper: BankConnectionStateMapper
  ) {}

  toDomain(bankConnectionDto: BankConnectionDto): BankConnection {
    return {
      connectionId: bankConnectionDto.id,
      bankId: bankConnectionDto.bank.id,
      state: this.bankConnectionStateMapper.toDomain(bankConnectionDto.state),
      lastSynchronizedAt: bankConnectionDto.lastSynchronizedAt
        ? { value: bankConnectionDto.lastSynchronizedAt }
        : null,
    };
  }
}
